/**
 * Minimal characters required for a meaningful message after
 * the raw quick questions are stripped.
 *
 * @type {number}
 */
export const MEANINGFUL_MESSAGE_MIN_THRESHOLD = 5;
